import ModalView from './modal-view.js';
import translator from '../translator.js';
import SessionTimeoutDialog
    from './templates/dialog-session-timeout.handlebars';

/**
 * A view for displaying a modal dialog to renew a user session.
 *
 * The view should be created with a user as the model.
 */
export default ModalView.extend({

    ui: {
        ...ModalView.prototype.ui,
        ...{
            continue: '.continue'
        }
    },

    events: {
        ...ModalView.prototype.events,
        ...{
            'click @ui.continue': 'continue'
        }
    },

    template: SessionTimeoutDialog,

    templateContext: function () {
        return { translator: translator };
    },

    /**
     * Destroy the dialog on logout.
     */
    onRender: function () {
        ModalView.prototype.onRender?.call(this);
        this.listenToOnce(this.model, 'logout', () => {
            window.location.reload();
        });
    },

    /**
     * Extend the user's login session.
     */
    continue: function () {
        this.model.keepalive();
        this.destroy();
    }
});
